(function () {
  const LAST_VISIT_KEY = 'aios:lastMeaningfulVisit';
  const SESSION_KEY = 'aios:sessionAudience';
  const PREVIOUS_VISIT_KEY = 'aios:previousVisit';

  function getAudience() {
    try {
      const existingAudience = sessionStorage.getItem(SESSION_KEY);
      const existingPrevious = Number(sessionStorage.getItem(PREVIOUS_VISIT_KEY) || 0);
      if (existingAudience) {
        return { audience: existingAudience, previousVisit: existingPrevious };
      }

      const previousVisit = Number(localStorage.getItem(LAST_VISIT_KEY) || 0);
      const sixMonths = 180 * 24 * 60 * 60 * 1000;
      const returning = previousVisit > 0 && Date.now() - previousVisit < sixMonths;
      const audience = returning ? 'returning' : 'first';

      sessionStorage.setItem(SESSION_KEY, audience);
      sessionStorage.setItem(PREVIOUS_VISIT_KEY, String(previousVisit));
      localStorage.setItem(LAST_VISIT_KEY, String(Date.now()));
      return { audience: audience, previousVisit: previousVisit };
    } catch (error) {
      return { audience: 'first', previousVisit: 0 };
    }
  }

  const visitor = getAudience();

  function applyAudience() {
    const isReturning = visitor.audience === 'returning';
    document.body.classList.toggle('aios-returning', isReturning);
    document.body.classList.toggle('aios-first-visit', !isReturning);

    document.querySelectorAll('[data-aios-new-rail]').forEach(function (rail) {
      const heading = rail.querySelector('[data-aios-dynamic-heading]');
      const firstHeading = rail.dataset.firstHeading || 'New This Week';
      const returningHeading = rail.dataset.returningHeading || 'New Since Your Last Visit';
      const fallbackHeading = rail.dataset.fallbackHeading || firstHeading;
      const items = Array.from(rail.querySelectorAll('[data-aios-published-at]'));

      if (!isReturning || !visitor.previousVisit) {
        if (heading) heading.textContent = firstHeading;
        items.forEach(function (item) { item.hidden = false; });
        return;
      }

      const newlyPublished = items.filter(function (item) {
        return Number(item.dataset.aiosPublishedAt || 0) > visitor.previousVisit;
      });

      if (newlyPublished.length >= 2) {
        items.forEach(function (item) { item.hidden = newlyPublished.indexOf(item) === -1; });
        if (heading) heading.textContent = returningHeading;
      } else {
        items.forEach(function (item) { item.hidden = false; });
        if (heading) heading.textContent = fallbackHeading;
      }
    });

    if (isReturning) {
      const priority = document.querySelector('[data-aios-role="priority"]')?.closest('.shopify-section');
      const recent = document.querySelector('[data-aios-role="recently"]')?.closest('.shopify-section');
      if (priority && recent && priority.parentNode === recent.parentNode) {
        recent.insertAdjacentElement('afterend', priority);
      }
    }
  }

  function bindRailButtons(root) {
    root.querySelectorAll('[data-aios-scroll]').forEach(function (button) {
      if (button.dataset.aiosBound === 'true') return;
      button.dataset.aiosBound = 'true';
      button.addEventListener('click', function () {
        const section = button.closest('.aios-section');
        const track = section?.querySelector('[data-aios-track]');
        if (!track) return;
        const direction = button.dataset.aiosScroll === 'next' ? 1 : -1;
        track.scrollBy({ left: track.clientWidth * .82 * direction, behavior: 'smooth' });
      });
    });
  }

  function bindComparisons(root) {
    root.querySelectorAll('[data-aios-comparison]').forEach(function (comparison) {
      const range = comparison.querySelector('input[type="range"]');
      if (!range || range.dataset.aiosBound === 'true') return;
      range.dataset.aiosBound = 'true';
      const update = function () {
        comparison.style.setProperty('--aios-position', range.value + '%');
      };
      range.addEventListener('input', update);
      update();
    });
  }

  function bindHeroSliders(root) {
    root.querySelectorAll('[data-aios-hero-slider]').forEach(function (slider) {
      if (slider.dataset.aiosBound === 'true') return;
      slider.dataset.aiosBound = 'true';
      const track = slider.querySelector('[data-aios-hero-track]');
      const dots = Array.from(slider.querySelectorAll('[data-aios-hero-dot]'));
      if (!track || dots.length === 0) return;

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
          setActive(index);
        });
      });

      let scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        }, 80);
      }, { passive: true });
    });
  }

  function initialize(root) {
    applyAudience();
    bindRailButtons(root || document);
    bindComparisons(root || document);
    bindHeroSliders(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
